<div class="row w-100 pt-3 text-center row-title">
  <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Un remboursement est en attente</div>
</div>
<div class="row w-100 pt-3 text-center">

  <div class="col-12">
    <form [formGroup]="updateIbanForm" (submit)="saveIban()">
      <div class="form-group pb-2">
        <p>Votre IBAN actuel : {{customer.iban}}</p>
      </div>
      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Veuillez mettre à jour votre IBAN*</span>
        <input type="text" class="form-control" placeholder="Entrez votre iBAN" formControlName="iban" required>
        @if (updateIbanFormSubmitted && updateIbanForm.controls.iban.errors) {
          <p class="error-message">{{ getError('iban') }}</p>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Nouveau BIC*</span>
        <input type="text" class="form-control" placeholder="BIC" formControlName="bic" required>
        @if (updateIbanFormSubmitted && updateIbanForm.controls.bic.errors) {
          <p class="error-message">{{ getError('bic') }}</p>
        }
      </div>
        <div class="form-group pb-2 checkbox">
            <input type="checkbox" id="generateSepa" (click)="setSepa($event)"/>
            <label for="generateSepa" class="box-grid">En cochant j'accepte la génération de mandat sepa.</label>
        </div>

      <div class="cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        @if (acceptSepa) {
          <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
        }
      </div>

    </form>
  </div>
</div>
